export default "__VITE_ASSET__W4N20caY__"